import type { PricingList } from 'api/types/pricing.types';
import { isPerItemService } from 'api/types/pricing.types';
import React from 'react';
import { Container } from 'react-bootstrap';

import AddItemRow from './addItemRow';
import Collapsible from './collapsible';

interface Props {
  data: PricingList.CombinedService;
  currency?: string;
  serviceType: PricingList.ServiceTypes;
}

const AddItems: React.FC<Props> = ({ data, currency, serviceType }) => {
  const renderPerItem = React.useCallback(
    (itemCategories: PricingList.ItemCategory[]) => <Collapsible list={itemCategories} currency={currency} serviceType={serviceType} />,
    [currency, serviceType]
  );

  const renderPerBag = React.useCallback(
    (price: number, discountedPrice?: number) => (
      <AddItemRow
        data={{ key: data.name, name: 'Bags', price, discountedPrice }}
        currency={currency}
        serviceType={serviceType}
        showHighlightedPrice
        category={serviceType}
        noPadding
      />
    ),
    [currency, data.name, serviceType]
  );

  return (
    <Container className={isPerItemService(data) ? '' : 'py-2 pr-7'}>
      {isPerItemService(data) ? renderPerItem(data.itemCategories) : renderPerBag(data.price, data.discountedPrice)}
    </Container>
  );
};

export default AddItems;
